/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-28 17:23:27
 * @LastEditors: K
 * @LastEditTime: 2022-10-09 13:57:52
 */
import { SearchOutlined } from '@ant-design/icons';
import { unwrapResult } from '@reduxjs/toolkit';
import { Button, Dropdown, Form, Input, Menu, Modal, notification, Space } from 'antd';
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../app/store';
import styles from './MembersManagementPage.module.css'
import { getAddMembers, getSearchMembersByPhone } from './MembersManagementPageSlice';
import { ThemeContext } from '../../theme/ThemeContext';
import { AddMembersModal } from './addMembersModal';

interface SearchMembersModalProps {
  visible: boolean
  onCancel: () => void
  onOk: (obj: any) => void
  openFn: () => void
}

export const SearchMembersModal = ({
  visible,
  onCancel,
  onOk,
  openFn,
}: SearchMembersModalProps): ReactElement => {

  const theme = useContext(ThemeContext)

  const inputRef = useRef<any>(null)

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [infoShow, setInfoShow] = useState(0)

  const [addBtnType, setAddBtnType] = useState(false) // 新增会员弹窗

  const [addMembersVisible, setAddMembersVisible] = useState(false) // 新增会员弹窗

  const [phoneNumber, setPhoneNumber] = useState(0)

  const [membersInfo, setMembersInfo] = useState<any>()

  const [patients, setPatients] = useState<any>()

  const [keywords, setKeywords] = useState('')

  const [isPatientNameOverlayVisible, setIsPatientNameOverlayVisible] = useState(false)

  useEffect(() => {
    if (!visible) {
      form.resetFields()
      setMembersInfo({})
      setInfoShow(0)
      setPhoneNumber(0)
      setKeywords('')
      setPatients([])
      setIsPatientNameOverlayVisible(false)

    }
  }, [visible])

  useEffect(() => {
    if (visible) {
      setMembersInfo({})
      setIsPatientNameOverlayVisible(false)
      setTimeout(() => {
        inputRef?.current?.focus()
      }, 200)
    }
  }, [visible])

  const patientOverlay = (
    <Menu style={{ maxHeight: 360, overflow: 'auto' }}>
      {patients?.map((p: any) => (
        <Menu.Item
          key={p.id}
          onClick={() => {
            setKeywords(p.memberName)
            setMembersInfo(p)
            setIsPatientNameOverlayVisible(false)
          }}
        >
          <Space>
            <span>{p.memberName}</span>
            <span>{p.memberPhone ? p?.memberPhone : ''}</span>
            <span>{p.cardNo ? p?.cardNo : ''}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  )

  useEffect(() => {
    if (visible) {
      getList(keywords)
    }
  }, [dispatch, keywords, visible])

  const getList = (keywords: any) => {
    dispatch(getSearchMembersByPhone({ keyword: keywords }))
      .then(unwrapResult)
      .then((res) => {
        setPatients(res || [])
      })
  }

  return (
    <>
      <Modal
        visible={visible}
        title='搜索会员'
        width={600}
        footer={null}
        onCancel={onCancel}
        maskClosable={false}
      >
        <div style={{
          minHeight: '50px',
        }}>
          <Form
            form={form}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 14 }}
            autoComplete="off"
            onFinish={(values) => setPhoneNumber(values.memberPhone)}
            onFinishFailed={() => setPhoneNumber(0)}
          >
            <Form.Item label='会员' name='memberName' rules={[{ required: true, message: '请选择会员' }]} style={{ position: 'relative', marginBottom: 12 }}>
              <Dropdown
                overlay={patientOverlay}
                visible={isPatientNameOverlayVisible}
                onVisibleChange={((v) => {
                  setIsPatientNameOverlayVisible(v)
                })}
              >
                <Input
                  allowClear
                  ref={inputRef}
                  placeholder='会员姓名/手机号/会员卡号'
                  prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
                  value={keywords}
                  onFocus={() => {
                    getList(keywords)
                    // setIsPatientNameOverlayVisible(true)
                    setInfoShow(0)
                  }}
                  onBlur={() => {
                    setTimeout(() => {
                      setIsPatientNameOverlayVisible(false)
                      setInfoShow(0)
                    }, 300)
                  }}
                  onClick={() => {
                    // setIsPatientNameOverlayVisible(true)
                  }}
                  onChange={(e) => {
                    if (e.target.value) {
                      setIsPatientNameOverlayVisible(true)
                      setInfoShow(0)
                      setMembersInfo({})
                    } else {
                      setMembersInfo({})
                    }
                    setKeywords(e.target.value)
                  }}
                  onPressEnter={(e) => e.preventDefault()}
                />
              </Dropdown>
              <Button
                type='primary'
                style={{ position: 'absolute', right: '-100px', top: 0 }}
                onClick={() => {
                  setAddMembersVisible(true)
                }}>
                新增会员
              </Button>
            </Form.Item>
            {membersInfo?.memberName && <>
              <Form.Item label="姓名" style={{ marginBottom: 12 }}>{membersInfo?.memberName}（{membersInfo?.memberPhone}）</Form.Item>
              <Form.Item label="账户余额" style={{ marginBottom: 12 }}>{membersInfo?.balanceMoney?.toFixed(2)}</Form.Item>
            </>}
          </Form>
        </div>
        <div className={styles.footerBtn}>
          <Space>
            <Button onClick={onCancel}>取消</Button>
            <Button
              type='primary'
              disabled={!keywords}
              onClick={() => {
                if (!membersInfo?.memberName) {
                  notification.warning({ message: '请选择会员' })
                  return
                }
                onOk(membersInfo)
              }}
            >确定</Button>
          </Space>
        </div>
      </Modal>
      <AddMembersModal // 新增会员
        visible={addMembersVisible}
        btnType={addBtnType}
        onCancel={() => setAddMembersVisible(false)}
        onOk={(data) => {
          dispatch(getAddMembers(data))
            .then(unwrapResult)
            .then(() => {
              console.log(data, "datadata")
              dispatch(getSearchMembersByPhone({ keyword: data?.memberPhone }))
                .then(unwrapResult)
                .then((res) => {
                  setAddMembersVisible(false)
                  onOk(res?.[0])
                  setMembersInfo(res?.[0])
                })
            })
            .finally(() => setAddBtnType(!addBtnType))
        }}
      />
    </>
  );
}

